export default __webpack_public_path__ + "static/media/imprint-data-policy-full-HD.9cda43df.jpg";